module.exports = __webpack_public_path__ + "static/img/153434_3_2.017b6e9c.jpg";